<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 财务中心->申请开票 -->
    <div class="main2">
      <div class="title">申请开票</div>
      <div v-if="web_invoice_tip != ''" class="tips" style="padding:15px;">
        <div v-html="web_invoice_tip" class="item">
          非对公账户付款不能开具发票。
        </div>
      </div>
      <div class="main2">
        <div class="info">
          <div class="item">
            <div class="top"><span>*</span>发票类型</div>
            <div>
              <el-select v-model="invoiceType" name="" id="" class="img">
                <el-option value="1" label="普通发票">普通发票</el-option>
                <el-option value="2" label="专用发票">专用发票</el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>发票抬头</div>
            <div class="bottom">
              <input
                v-model="invoiceName"
                type="text"
                placeholder="请输入发票抬头"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>税号</div>
            <div class="bottom">
              <input
                v-model="invoiceNum"
                type="text"
                placeholder="请输入税号"
                class="img"
              />
            </div>
          </div>

          <div class="item">
            <div class="top">
              <span v-if="invoiceType == 2">*</span>注册办公地址
            </div>
            <div class="bottom">
              <input
                v-model="regAddress"
                type="text"
                placeholder="请输入注册办公地址"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top">
              <span v-if="invoiceType == 2">*</span>注册固定电话
            </div>
            <div class="bottom">
              <input
                v-model="regTel"
                type="text"
                placeholder="请输入注册固定电话"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top">
              <span v-if="invoiceType == 2">*</span>开户银行名称
            </div>
            <div class="bottom">
              <input
                v-model="bankName"
                type="text"
                placeholder="请输入开户银行名称"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top">
              <span v-if="invoiceType == 2">*</span>基本开户账号
            </div>
            <div class="bottom">
              <input
                v-model="bankNum"
                type="text"
                placeholder="请输入基本开户账号"
                class="img"
              />
            </div>
          </div>

          <div class="item">
            <div class="top">
              <span>*</span>订单号
              <span class="tip">(多个用订单号“,”号分隔)</span>
            </div>
            <div class="bottom">
              <input
                v-model="orderNum"
                type="text"
                placeholder="请输入订单号"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>发票内容</div>
            <div class="bottom">
              <input
                v-model="invoiceInfo"
                type="text"
                placeholder="请输入发票内容"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>开票金额</div>
            <div class="bottom">
              <input
                v-model="invoiceMoney"
                type="text"
                placeholder="请输入开票金额"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>收票地址</div>
            <div class="bottom">
              <input
                v-model="linkAddress"
                type="text"
                placeholder="请输入收票地址"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>收票人</div>
            <div class="bottom">
              <input
                v-model="linkMan"
                type="text"
                placeholder="请输入收票人"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span>*</span>收票人电话</div>
            <div class="bottom">
              <input
                v-model="cellPhone"
                type="text"
                placeholder="请输入收票人电话"
                class="img"
              />
            </div>
          </div>
          <div class="item">
            <div class="top"><span></span>备注</div>
            <div class="bottom bottom2">
              <textarea
                v-model="remark"
                name=""
                id=""
                cols="30"
                rows="10"
                class="img"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="buttons flexStyle2">
          <div class="hands item" @click="submitGetOrderBefore">
            提 交
          </div>
        </div>
      </div>
    </div>
    <!-- 财务中心->申请开票 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { applyGetOrderRequest } from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      invoiceNum: "", // 1.1.发票税号
      invoiceMoney: "", // 1.2.开票金额
      invoiceType: "1", // 1.3.发票类型(1普通发票;2专用发票;3电子发票)
      linkMan: "", // 1.4.联系人
      cellPhone: "", // 1.5.联系电话
      linkAddress: "", // 1.5.联系地址
      orderNum: "", // 1.6.订单号
      invoiceInfo: "", // 1.7.发票内容
      remark: "", // 1.8.备注

      timer: null, // 1.9.定时器对象，用于查询用户信息直到查询到位置
      token: "", // 1.10.token
      submitSwitch: true, // 1.11.请求开关

      invoiceName: "", // 1.12.发票抬头
      bankName: "", // 1.13.开户银行名称
      bankNum: "", // 1.14.基本开户账号
      regAddress: "", // 1.15.注册办公地址
      regTel: "", // 1.16.注册固定电话
      web_invoice_tip: "",
    };
  },

  components: {
    // 2.components
  },

  methods: {
    // 3.methods
    submitGetOrderBefore() {
      // 3.1.确认开票之前
      if (this.verifacation() && this.submitSwitch) {
        this.submitGetOrder();
      }
    },

    verifacation() {
      // 3.2.校验表单方法
      if (!this.invoiceName.trim()) {
        // 校验发票抬头
        this.$notify({
          title: "提示",
          message: "请输入发票抬头",
        });
        return;
      }

      if (!this.invoiceNum.trim()) {
        // 校验税号
        this.$notify({
          title: "提示",
          message: "请输入税号",
        });
        return;
      }

      if (this.invoiceType == 2) {
        // 如果是专票必须要输入和验证其他字段的数据
        if (!this.regAddress.trim()) {
          // 注册办公地址
          this.$notify({
            title: "提示",
            message: "请输入注册办公地址",
          });
          return;
        }

        if (!this.regTel.trim()) {
          // 注册固定电话
          this.$notify({
            title: "提示",
            message: "请输入注册固定电话",
          });
          return;
        }

        if (!this.bankName.trim()) {
          // 校验开户银行名称
          this.$notify({
            title: "提示",
            message: "请输入开户银行名称",
          });
          return;
        }

        if (!this.bankNum.trim()) {
          // 校验基本开户账号
          this.$notify({
            title: "提示",
            message: "请输入基本开户账号",
          });
          return;
        }
      }

      if (!this.orderNum.trim()) {
        // 校验订单号
        this.$notify({
          title: "提示",
          message: "请输入订单号",
        });

        return;
      }

      if (!this.invoiceInfo.trim()) {
        // 校验发票内容
        this.$notify({
          title: "提示",
          message: "请输入发票内容",
        });
        return;
      }

      if (!this.invoiceMoney.trim()) {
        // 校验开票金额
        this.$notify({
          title: "提示",
          message: "请输入开票金额",
        });

        return;
      }

      if (!this.linkAddress.trim()) {
        // 校验收票地址
        this.$notify({
          title: "提示",
          message: "请输入收票地址",
        });

        return;
      }

      if (!this.linkMan.trim()) {
        // 校验联系人
        this.$notify({
          title: "提示",
          message: "请输入收票人",
        });

        return;
      }

      if (this.cellPhone.trim().length != 11) {
        // 校验联系电话
        this.$notify({
          title: "提示",
          message: "请输入11位数正确电话",
        });

        return;
      }

      return true;
    },

    submitGetOrder() {
      // 3.3.确认开票
      this.submitSwitch = false;
      let data = {
        invoiceNum: this.invoiceNum,
        invoiceMoney: this.invoiceMoney,
        invoiceType: this.invoiceType,
        linkMan: this.linkMan,
        cellPhone: this.cellPhone,
        linkAddress: this.linkAddress,
        orderNum: this.orderNum,
        invoiceInfo: this.invoiceInfo,
        remark: this.remark,
        bankName: this.bankName,
        bankNum: this.bankNum,
        regAddress: this.regAddress,
        regTel: this.regTel,
      };

      applyGetOrderRequest(data).then((res) => {
        if (res) {
          this.submitSwitch = true;
          this.$message({
            type: "success",
            message: res.msg,
          });

          this.invoiceNum = "";
          this.invoiceMoney = "";
          this.invoiceType = "";
          this.linkMan = "";
          this.cellPhone = "";
          this.linkAddress = "";
          this.orderNum = "";
          this.invoiceInfo = "";
          this.remark = "";
          this.invoiceName = "";
          this.bankName = "";
          this.bankNum = "";
          this.regAddress = "";
          this.regTel = "";
          this.invoiceType = 1;

          window.scroll(0, 0);
        }
      });
    },
  },

  mounted() {
    // 4.4.mounted
    if (localStorage.token) {
      // 4.4.1.修改密码需要token
      this.token = localStorage.token;
    }
    if (localStorage.baseInfo) {
      this.baseInfo = JSON.parse(localStorage.baseInfo);
      this.web_invoice_tip = this.baseInfo.web_invoice_tip || "";
    }
  },
};
</script>
